import { useNewCode, useVariant } from '@calendly/feature-check-react'
import { useMemo } from 'react'

import {
  AI_CHAT_DISCOVERY_EXPERIMENT_KEY,
  AI_CHAT_DISCOVERY_FAB_APPEARANCE,
  AI_CHAT_DISCOVERY_VARIANT,
  getAiChatDiscoveryEffectiveVariant,
} from './constants'

const { BUTTON_ONLY, CONTROL } = AI_CHAT_DISCOVERY_VARIANT
const { STRING } = AI_CHAT_DISCOVERY_FAB_APPEARANCE

/** CAF chat + AI discovery experiment: nav link, floating FAB, and FAB shape (`icon` | `string`). */
export const useAiChatDiscoveryExperiment = () => {
  const isCafChatEnabled = useNewCode('caf_frontend_chat_feature')?.enabled
  const variant = useVariant(AI_CHAT_DISCOVERY_EXPERIMENT_KEY, true)

  return useMemo(() => {
    const effectiveVariant = getAiChatDiscoveryEffectiveVariant(variant)

    // Phase 1: only `button_test_d` shows the string button
    const eligibleForFloating = Boolean(
      isCafChatEnabled
        && effectiveVariant === BUTTON_ONLY
    )

    let fabAppearance = null
    if (eligibleForFloating) {
      fabAppearance = STRING
    }

    const showsLeftNavAiLink = Boolean(
      isCafChatEnabled && effectiveVariant === CONTROL
    )

    return {
      showsFloatingLauncher: Boolean(eligibleForFloating && fabAppearance),
      showsLeftNavAiLink,
      fabAppearance,
    }
  }, [isCafChatEnabled, variant])
}
